import React from 'react';
import PropTypes from 'prop-types';
import QuoteViewHeaderComponent from './quote-details/QuoteHeaderComponent';
import QuoteMachineInformationComponent from './quote-details/QuoteMachineInformationComponent';
import QuoteInformationComponent from './quote-details/QuoteInformationComponent';
import QuoteStatusComponent from './quote-details/QuoteStatusComponent';
import QuoteProductsComponent from './quote-products/QuoteProductsComponent';
import QuoteCustomLineItemsComponent from './quote-products/QuoteCustomLineItemsComponent';
import QuoteInstallationComponent from './quote-products/QuoteInstallationComponent';
import QuoteExpeditedShippingComponent from './quote-products/QuoteExpeditedShippingComponent';
import QuoteDocumentsContainer from './quote-documents/QuoteDocumentsContainer';
import QuotePricingComponent from './quote-details/QuotePricingComponent';
import QuoteActivitiesComponent from './quote-details/QuoteActivitiesComponent';
import { getDefaultPriceMode } from '../../quotes/quotePriceMode';
import QuoteView from './quoteView';
//import './QuoteViewComponent.scss';
import _ from 'lodash';
import { callbackOnWidthChange } from '@ami/react/core';
import LeadTimeWarnings from '../../quotes/LeadTimeWarnings';
import AmiTaskPanel from '../../ami-tasks/AmiTaskPanel';
import { appConfig } from '@ami/react/core';
import QuoteDiscountComponent from './quote-details/QuoteDiscountComponent';

class QuoteViewComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.defaultPriceModeCallback = this.defaultPriceModeCallback.bind(this);

    this.state = {
      selectedPriceMode: getDefaultPriceMode(),
      width: window.innerWidth,
    };
  }
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView),
    onQuoteUpdated: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onExpire: PropTypes.func.isRequired,
    onDealerBranchChange: PropTypes.func.isRequired,
    onPriceZoneChange: PropTypes.func.isRequired,
    onReSendCreateNotification: PropTypes.func.isRequired,
    onAddCustomActivity: PropTypes.func.isRequired,
    onRequestNewLeadTime: PropTypes.func.isRequired,
    onCopyQuote: PropTypes.func.isRequired,
    onReOpen: PropTypes.func.isRequired,
    onUpdatePartNumbers: PropTypes.func.isRequired,
  };

  componentDidMount() {
    window.addEventListener(
      'resize',
      _.debounce(this.setDefaultPriceMode, 250)
    );
  }
  componentWillUnmount() {
    window.removeEventListener(
      'resize',
      _.debounce(this.setDefaultPriceMode, 250)
    );
  }

  defaultPriceModeCallback = (newWidth) => {
    this.setState({
      width: newWidth,
      selectedPriceMode: getDefaultPriceMode(),
    });
  };

  setDefaultPriceMode = () => {
    callbackOnWidthChange(this.state.width, this.defaultPriceModeCallback);
  };

  updatePriceMode = (priceModeId) => {
    this.setState({ selectedPriceMode: priceModeId });
  };

  render() {
    const {
      quote,
      onQuoteUpdated,
      onDealerBranchChange,
      onPriceZoneChange,
      onReSendCreateNotification,
      onAddCustomActivity,
      onRequestNewLeadTime,
      onCopyQuote,
      onUpdatePartNumbers,
    } = this.props;
    if (!quote) return null;

    const { selectedPriceMode } = this.state;

    const poSubmitted =
      quote.statusInformation.isAccepted || quote.statusInformation.isCompleted;
    const machineMissing = quote.statusInformation.machineAndModelMissing;
    const couplerMissing =
      quote.statusInformation.anyCouplerDecisionNotSpecified;
    const enabledAddNew = !(
      quote.statusInformation.isCompleted || quote.statusInformation.isCancelled
    );

     return (
      <div>
        <QuoteViewHeaderComponent
          quote={quote}
          onCancel={this.props.onCancel}
          onExpire={this.props.onExpire}
          onDealerBranchChange={onDealerBranchChange}
          onPriceZoneChange={onPriceZoneChange}
          onReSendCreateNotification={onReSendCreateNotification}
          onAddCustomActivity={onAddCustomActivity}
          onRequestNewLeadTime={onRequestNewLeadTime}
          onCopyQuote={onCopyQuote}
          onReOpen={this.props.onReOpen}
          refreshQuote={onQuoteUpdated}
          onUpdatePartNumbers={onUpdatePartNumbers}
        />
        {poSubmitted && quote.relatedOrders.length === 0 && (
          <div className="row row-cols-1">
            <div className="col">
              <div className="banner-container">
                <div className="card-body alert alert-success">
                  <div className="card-title text-lg">
                    Thank You for your Purchase Order!
                  </div>
                  <div className="card-text">
                    {
                      'Your submitted PO will be processed within 24 business hours. AMI will contact you if additional information is required.'
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <LeadTimeWarnings
          machineMissing={machineMissing}
          couplerMissing={couplerMissing}
          fullWidth={true}
        />
        <div className="row row-cols-1 row-cols-md-3">
          <div className="col d-flex">
            <QuoteInformationComponent quote={quote} />
          </div>
          <div className="col d-flex">
            <QuoteMachineInformationComponent quote={quote} />
          </div>
          <div className="col d-flex">
            <QuoteStatusComponent quote={quote} refreshQuote={onQuoteUpdated} />
          </div>
        </div>
        <div className="row row-cols-1">
          <div className="col">
            <QuoteProductsComponent
              quote={quote}
              selectedPriceMode={selectedPriceMode}
              updatePriceMode={this.updatePriceMode}
              refreshQuote={onQuoteUpdated}
            />
          </div>
        </div>
        <div className="row row-cols-1">
          <div className="col">
            <QuoteCustomLineItemsComponent
              quote={quote}
              selectedPriceMode={selectedPriceMode}
            />
          </div>
        </div>
        {quote.expeditedShipping && (
          <div className="row row-cols-1 row-cols-md-2 expedited-shipping">
            <QuoteExpeditedShippingComponent quote={quote} />
          </div>
        )}
        {quote.installationEnabled && (
          <div className="row row-cols-1">
            <div className="col">
              <QuoteInstallationComponent
                quote={quote}
                selectedPriceMode={selectedPriceMode}
              />
            </div>
          </div>
        )}
        <div className="row row-cols-1 row-cols-md-2">
          <div className="col d-flex">
            <QuoteDocumentsContainer
              quote={quote}
              onDocumentsUpdated={this.props.onQuoteUpdated}
            />
          </div>
          <div className="col d-flex">
            <QuotePricingComponent
              quote={quote}
              selectedPriceMode={selectedPriceMode}
            />
          </div>
        </div>
        {quote.optInDiscountsWithDocument && (
          <div className="row row-cols-1">
            {quote.optInDiscountsWithDocument.map((item, i) =>
            (
            <div className="col-6 d-flex" key={i}>
              <QuoteDiscountComponent
                quote={quote}
                quoteDiscount={item}
                refreshQuote={onQuoteUpdated}
              />
            </div>
          ))}
          </div>
        )}
        {appConfig.isManagementApp && (
          <div className="row row-cols-1">
            <AmiTaskPanel
              idrelated={quote.id}
              isOrder={false}
              enabledAddNew={enabledAddNew}
            />
          </div>
        )}
        <div className="row row-cols-1">
          <div className="col">
            <QuoteActivitiesComponent quote={quote} />
          </div>
        </div>
      </div>
    );
  }
}

export default QuoteViewComponent;
